export default [
  {
    version: '1.2.0',
    title: 'Demetra',
    publishDate: '22 Nov, 2023',
    logs: {
      new: [
        'PAGE : <code>Apps/CRM/Deals</code>',
        'PAGE : <code>Apps/Kanban/Kanban</code>',
        'PAGE : <code>Apps/Kanban/Boards</code>',
        'PAGE : <code>Apps/Kanban/Create-Board</code>',
        'PAGE : <code>Apps/Calendar</code>',
        'PAGE : <code>Pages/Faq/Faq-Tab</code>',
        'PAGE : <code>Pages/Landing/Alternate</code>',
        'PAGE : <code>Pages/Timeline</code>',
        'PAGE : <code>Pages/Coming-Soon</code>',
        'PAGE : <code>Modules/Forms/Wizard</code>',
        'PAGE : <code>Modules/Components/Calendar</code>',
        'PAGE : <code>Modules/Components/Draggable</code>',
        'PAGE : <code>Modules/Widgets</code>',
        'COMPONENT : <code>FullCalendar</code>',
        'COMPONENT : <code>PhoenixDroppable</code>',
        'COMPONENT : <code>PhoenixFloatingLabel</code>',
        'COMPONENT : <code>ScrollSpy</code>',
        'FEATURE : <code>Chat Demo (floating widget)</code>',
        'FEATURE : <code>Chat file and image attachments</code>'
      ],
      update: [
        'PACKAGE: typescript to v5.2.2',
        'PACKAGE: swiper to v11.0.3',
        'PACKAGE: @iconscout/react-unicons to v2.0.2',
        'PACKAGE: eslint-config-prettier to v9.0.0',
        'PACKAGE: eslint-plugin-prettier to v5.0.1',
        'PACKAGE: prettier to v3.0.3'
      ],
      fix: ['Minor Bugs']
    }
  },
  {
    version: '1.1.0',
    title: 'Theseus',
    publishDate: '12 October, 2023',
    logs: {
      new: [
        'Dashboard : <code>CRM</code>',
        'PAGE : <code>CRM/Analytics</code>',
        'PAGE : <code>CRM/Deal-Details</code>',
        'PAGE : <code>CRM/Lead</code>',
        'PAGE : <code>CRM/Lead-Details</code>',
        'PAGE : <code>CRM/Reports</code>',
        'PAGE : <code>CRM/Report-Details</code>',
        'PAGE : <code>CRM/Add-Contact</code>',
        'PAGE : <code>pricing/pricing-grid</code>',
        'PAGE : <code>authentication/split/sign-in</code>',
        'PAGE : <code>authentication/split/sign-up</code>',
        'PAGE : <code>authentication/split/sign-out</code>',
        'PAGE : <code>authentication/split/forgot-password</code>',
        'PAGE : <code>authentication/split/reset-password</code>',
        'PAGE : <code>authentication/split/lock-screen</code>',
        'PAGE : <code>authentication/split/2FA</code>',
        'PAGE : <code>authentication/card/sign-in</code>',
        'PAGE : <code>authentication/card/sign-up</code>',
        'PAGE : <code>authentication/card/sign-out</code>',
        'PAGE : <code>authentication/card/forgot-password</code>',
        'PAGE : <code>authentication/card/reset-password</code>',
        'PAGE : <code>authentication/card/lock-screen</code>',
        'PAGE : <code>authentication/card/2FA</code>',
        'PAGE : <code>migrations</code>',
        'COMPONENT : <code>Unicon</code>',
        'COMPONENT : <code>PhoenixLoader</code>'
      ],
      update: [
        'Migrated from Font Awesome React  <code>Global Use</code> to <code>Individual Use</code> for improved icon management.',
        'Added <code>footerProps</code> in <code>AdvanceTable</code> columns definition.',
        'Example added for all <code>Icon</code> sets.'
      ],
      fix: ['Minor Bugs']
    }
  }
];
